export enum DonationAction {
  CreateProduct = 'CreateProduct',
}
